import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import s from "./Clock.module.css";
function getGreeting(h) {
    if (h < 12)
        return "Good morning";
    if (h < 18)
        return "Good afternoon";
    if (h < 22)
        return "Good evening";
    return "Good night";
}
function formatTime() {
    const n = new Date();
    return `${String(n.getHours()).padStart(2, "0")}:${String(n.getMinutes()).padStart(2, "0")}`;
}
export default function Clock() {
    const [time, setTime] = useState(formatTime);
    const [greeting, setGreeting] = useState(() => getGreeting(new Date().getHours()));
    useEffect(() => {
        const id = setInterval(() => {
            const n = new Date();
            setTime(formatTime());
            setGreeting(getGreeting(n.getHours()));
        }, 1000);
        return () => clearInterval(id);
    }, []);
    return (_jsxs("div", { className: s.midLeft, children: [_jsx("div", { className: s.time, children: time }), _jsxs("div", { className: s.greet, children: [greeting, ", Stephen."] })] }));
}
//# sourceMappingURL=Clock.js.map